var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkAsReadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.141,
    height: 15.889,
    viewBox: "0 0 17.141 15.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Read_message",
    "data-name": "Read message",
    transform: "translate(-653.569 -660.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M282.372,261.966h-5.083a1.492,1.492,0,0,1-1.491-1.492v-8.948a1.492,1.492,0,0,1,1.491-1.492h12.528a1.492,1.492,0,0,1,1.492,1.492v6.69",
    transform: "translate(378.417 411)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.293
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x1: 0.649,
    transform: "translate(660.79 672.966)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.293
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M278.184,252.421l5.369,4.176,5.369-4.176",
    transform: "translate(378.417 411)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.293
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x2: 1.319,
    transform: "translate(669.066 669.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M291.2,261.1l-3.619,3.408-1.645-1.549",
    transform: "translate(378.417 411)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.546
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsReadIcon);
export default __webpack_public_path__ + "static/media/mark-as-read-icon.888418a2db986bb971d971bf83ed1236.svg";
export { ForwardRef as ReactComponent };